import createIcon from '../../createIcon';

/**
 * @component @name NoSim
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuMjM5OSA0LjE4OTk0QzE5LjIzOTkgMy4wODk5NCAxOC4zNDk5IDIuMTg5OTQgMTcuMjQ5OSAyLjE4OTk0SDEwLjI0OTlMNy45MDk4OCA0LjUyOTk0TDE5LjI0OTkgMTUuODY5OUwxOS4yMzk5IDQuMTg5OTRaTTMuODk5ODggMy4wNjk5NEwyLjYyOTg4IDQuMzM5OTRMNS4yNDk4OCA2Ljk1OTk0VjE4LjE4OTlDNS4yNDk4OCAxOS4yODk5IDYuMTQ5ODggMjAuMTg5OSA3LjI0OTg4IDIwLjE4OTlIMTcuMjU5OUMxNy42MDk5IDIwLjE4OTkgMTcuOTI5OSAyMC4wODk5IDE4LjIxOTkgMTkuOTI5OUwyMC4wOTk5IDIxLjgwOTlMMjEuMzY5OSAyMC41Mzk5TDMuODk5ODggMy4wNjk5NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoSim = createIcon('NoSim', [
  [
    'path',
    {
      d: 'M19.2399 4.18994C19.2399 3.08994 18.3499 2.18994 17.2499 2.18994H10.2499L7.90988 4.52994L19.2499 15.8699L19.2399 4.18994ZM3.89988 3.06994L2.62988 4.33994L5.24988 6.95994V18.1899C5.24988 19.2899 6.14988 20.1899 7.24988 20.1899H17.2599C17.6099 20.1899 17.9299 20.0899 18.2199 19.9299L20.0999 21.8099L21.3699 20.5399L3.89988 3.06994Z',
      key: '1bcoam',
    },
  ],
]);

export default NoSim;
